import { render, staticRenderFns } from "./TestEditor.vue?vue&type=template&id=52d5dce4&"
import script from "./TestEditor.vue?vue&type=script&lang=js&"
export * from "./TestEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports